import { useState, useEffect } from 'react'

interface UseCountdownTimerProps {
  expiresAt?: Date | null
}

export const useCountdownTimer = ({ expiresAt }: UseCountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<string>('00:00')

  useEffect(() => {
    if (!expiresAt) {
      setTimeLeft('00:00')
      return
    }

    const updateTimer = () => {
      const now = new Date()
      const expiration = new Date(expiresAt)
      const diff = expiration.getTime() - now.getTime()

      if (diff <= 0) {
        setTimeLeft('00:00')
        return
      }

      const minutes = Math.floor(diff / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
      setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`)
    }

    const timerId = setInterval(updateTimer, 1000)
    updateTimer() // Initial update

    return () => {
      clearInterval(timerId)
    }
  }, [expiresAt])

  return timeLeft
} 